import { DeleteOutlineOutlined } from '@mui/icons-material';
import { ListItemIcon, ListItemText } from '@mui/material';

import { useState } from 'react';

import type { DocumentType } from '@/gql';

import type { CONFIRM_DELETE_DIALOG_FILE_FRAGMENT } from '../../../../dialogs/ConfirmFileDeleteDialog';
import { ConfirmFileDeleteDialog } from '../../../../dialogs/ConfirmFileDeleteDialog';

import { MaybeUsableMenuItem } from './MaybeUnusableMenuItem';

interface Props {
  file: DocumentType<typeof CONFIRM_DELETE_DIALOG_FILE_FRAGMENT>;
  canEdit: boolean;
  canLockRoot: boolean;
  unusableExplanation: string | null;
  onClose: () => void;
}

export const DeleteFileMenuItem = ({
  file,
  canEdit,
  canLockRoot,
  unusableExplanation,
  onClose,
}: Props) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <MaybeUsableMenuItem
        isUsable={canEdit}
        isExpectedUsable={canLockRoot}
        unusableExplanation={unusableExplanation}
        onClick={() => {
          setDialogOpen(true);
          onClose();
        }}
      >
        <ListItemIcon>
          <DeleteOutlineOutlined />
        </ListItemIcon>
        <ListItemText primary="Delete" />
      </MaybeUsableMenuItem>
      <ConfirmFileDeleteDialog
        file={file}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};
